import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStats = ({ stats = {}, className = "" }) => {
  const defaultStats = {
    totalPatients: 24,
    activeToday: 18,
    highRiskPatients: 3,
    avgSeverityScore: 4.2,
    newAlertsCount: 5,
    completedAssessments: 156
  };

  const dashboardStats = { ...defaultStats, ...stats };

  const statCards = [
    {
      id: 'total-patients',
      title: 'Total Patients',
      value: dashboardStats?.totalPatients,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      trend: '+2 this week',
      trendIcon: 'TrendingUp',
      trendColor: 'text-success'
    },
    {
      id: 'active-today',
      title: 'Active Today',
      value: dashboardStats?.activeToday,
      icon: 'Activity',
      color: 'text-success',
      bgColor: 'bg-success/10',
      trend: `${Math.round((dashboardStats?.activeToday / dashboardStats?.totalPatients) * 100)}% of total`,
      trendIcon: 'CheckCircle',
      trendColor: 'text-success'
    },
    {
      id: 'high-risk',
      title: 'High Risk Patients',
      value: dashboardStats?.highRiskPatients,
      icon: 'AlertTriangle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      trend: 'Requires attention',
      trendIcon: 'AlertCircle',
      trendColor: 'text-error'
    },
    {
      id: 'avg-severity',
      title: 'Avg Severity Score',
      value: `${dashboardStats?.avgSeverityScore}/10`,
      icon: 'BarChart3',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      trend: '-0.3 from last week',
      trendIcon: 'TrendingDown',
      trendColor: 'text-success'
    },
    {
      id: 'new-alerts',
      title: 'New Alerts',
      value: dashboardStats?.newAlertsCount,
      icon: 'Bell',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      trend: 'Last 24 hours',
      trendIcon: 'Clock',
      trendColor: 'text-muted-foreground'
    },
    {
      id: 'assessments',
      title: 'Completed Assessments',
      value: dashboardStats?.completedAssessments,
      icon: 'FileCheck',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      trend: '+12 this week',
      trendIcon: 'TrendingUp',
      trendColor: 'text-success'
    }
  ];

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 ${className}`}>
      {statCards?.map((stat) => (
        <div
          key={stat?.id}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-soft transition-shadow duration-200"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 ${stat?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon 
                name={stat?.icon} 
                size={24} 
                color={`var(--color-${stat?.color?.replace('text-', '')})`}
              />
            </div>
            <div className="text-right">
              <div className="text-2xl font-bold text-foreground">{stat?.value}</div>
            </div>
          </div>

          <div className="space-y-2">
            <h3 className="text-sm font-medium text-foreground">{stat?.title}</h3>
            <div className="flex items-center space-x-1">
              <Icon 
                name={stat?.trendIcon} 
                size={14} 
                color={`var(--color-${stat?.trendColor?.replace('text-', '')})`}
              />
              <span className={`text-xs ${stat?.trendColor}`}>
                {stat?.trend}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;